module.exports = __webpack_public_path__ + "static/odland-3fff54c24a72b3751b8227bed4e41fdb.jpg";